import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {TransportationService} from '../../api/transportation.service';
import {Observable} from 'rxjs';
import {switchMap} from 'rxjs/operators';

@Component({
  selector: 'app-segment-products',
  templateUrl: './segment-details.component.html',
  styleUrls: ['./segment-details.component.scss']
})
export class SegmentDetailsComponent implements OnInit {

  constructor(private transportationService: TransportationService,
              private router: Router,
              private route: ActivatedRoute) {
  }

  product$: Observable<any>;
  zone$: Observable<any>;

  ngOnInit() {
    this.zone$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.transportationService.getProducts(params.get('transport'), params.get('zone')))
    );
    this.product$ = this.route.paramMap.pipe(
      switchMap((params: ParamMap) =>
        this.transportationService.getDetailsProduct(params.get('transport'), params.get('zone'), params.get('product')))
    );
  }


}
